import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import "./index.css"
import DropDownField from '../../helpers/DropDownField'

import { OrganizationChart } from 'primereact/organizationchart'

import { getUserRolesByCompanyId } from '../../services/api/user'

import { raiseToast } from '../../services/redux/reducers/toast/toast'

import { getFullName } from '../../utils'
import Draggable from 'react-draggable'


const OrganizationHierarchy = () => {

    const [selectedBranchId, setSelectedBranchId] = useState(1)

    const [userRoles, setUserRoles] = useState([])

    const userDetails = useSelector((state) => state.userDetails)
    const userNameDetails = useSelector((state) => state.userDetails.userNameDetails)
    
    const branches = userDetails.PMCompanyDetails.companyBranches
    const companyUsers = userDetails.PMCompanyDetails.companyUsers
    const companyRoles =  userDetails.PMCompanyDetails.companyRoles

    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        getActiveUserRoles()
    }, [companyUsers])

    const getActiveUserRoles = async () => {
        const data = { companyId: 1 }
        let userRolesResponse = await getUserRolesByCompanyId(data)
        if (userRolesResponse.failure) {
            return dispatch(raiseToast({severity: 'error', detail: userRolesResponse.data.error, life: 3000}))
        }

        let avoidedNames = ["system", "procmart", "petty cash", "pettycash"]

        const activeUserRoles = []
        userRolesResponse.data.map(eachUserRole => {
            const relatedCompanyUser = companyUsers.find(eachCompanyUser => eachCompanyUser.userId === eachUserRole.userId && eachUserRole.statusId === 1)

            if (relatedCompanyUser && !avoidedNames.includes(relatedCompanyUser.firstName.toLowerCase()) && !avoidedNames.includes(relatedCompanyUser.lastName?.toLowerCase())){
                activeUserRoles.push({...eachUserRole})
            }
        })
        
        setUserRoles(activeUserRoles)
    }

    const handleBranchChange = (e) => {
        setSelectedBranchId(e.target.value)
    }

    const buildOrgChartTree = (selectedBranchRelatedUserRoles, managerId, visited = new Set()) => {
        if (visited.has(managerId)) {
            return []
        }
        visited.add(managerId)

        const managerRelatedUserRoles = selectedBranchRelatedUserRoles.filter(eachUserRole => eachUserRole.managerId === managerId)

        let relatedUsers = []
        managerRelatedUserRoles.map(eachUserRole => {
            const relatedCompanyRole = companyRoles.find(eachCompanyRole => eachCompanyRole.companyRoleId === eachUserRole.companyRoleId)
            const relatedUserDetails = companyUsers.find(eachCompanyUser => eachCompanyUser.userId === eachUserRole.userId)

            const userCardInfo = {
                expanded: true,
                type: 'person',
                data: {
                    image: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',

                    name: getFullName(relatedUserDetails.firstName, relatedUserDetails.lastName),
                    title: relatedCompanyRole.companyRoleName,
                    userId: relatedUserDetails.userId
                },
                children: buildOrgChartTree(selectedBranchRelatedUserRoles, relatedUserDetails.userId, visited) || [],
            }
            relatedUsers.push(userCardInfo)
        })

        return relatedUsers
    }

    const generateOrgChartData = () => {
        const piyushUserRoleDetails = userRoles.find(eachUserRole => eachUserRole.userId == 174)

        if (!piyushUserRoleDetails) {
            return []
        }

        const piyushCompanyRole = companyRoles.find(eachCompanyRole => eachCompanyRole.companyRoleId === piyushUserRoleDetails.companyRoleId)
        const piyushUserDetails = companyUsers.find(eachCompanyUser => eachCompanyUser.userId === piyushUserRoleDetails.userId)

        const visited = new Set()
        const selectedBranchRelatedUserRoles = userRoles.filter(eachUser => eachUser.branchId === parseInt(selectedBranchId))

        const orgChartData = [
            {
                expanded: true,
                type: 'person',
                data: {
                    image: 
                        // <img src={userNameDetails.profileImg} alt='profile image' className="profile-img"/> ,
                        'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',

                        name: getFullName(piyushUserDetails.firstName, piyushUserDetails.lastName),
                    title: piyushCompanyRole.companyRoleName,
                    userId: piyushUserDetails.userId
                },
                children: buildOrgChartTree(selectedBranchRelatedUserRoles, piyushUserDetails.userId, visited) || [],
            },
        ]

        return orgChartData
    }

    const nodeTemplate = (node) => {
        if (node.type === 'person') {
            return (
                <div className="flex flex-column align-items-center justify-content-center">
                    <div className="flex flex-column align-items-center" style={{ justifyContent: 'start', height: '145px', width: '115px' }}>
                        <div className='chart-card-top'></div>
                        <div className="flex flex-column align-items-center p-1 mt-2">
                            <img  src={node.data.image} className="org-profile-img" />
                            <span style={{cursor: 'pointer'}} onClick={() => navigate(`/editUser/${node.data.userId}`)} className="mb-2 node-name">{node.data.name}</span>
                            <span className='node-sub-titile'>{node.data.title}</span>
                        </div>
                    </div>
                </div>
            )
        }
        return <span>{node.label}</span>
    }

    return (
        <div className="organization-chart-container" >
            <h4 className='mb-3'>ORGANIZATION CHART</h4>
            <div className="branch-filter" style={{ zIndex: "10", position:"relative"}}>
                <DropDownField labelText="Select Branch" name="branch" options={branches} optionLabel="branchName" optionValue="branchId" value={selectedBranchId} onChange={handleBranchChange} placeholder="Select a branch" style={{ width: '300px' }}/>
            </div>

            {userRoles.length && companyUsers.length && selectedBranchId ? (
                <Draggable >
                    <OrganizationChart value={generateOrgChartData()} nodeTemplate={nodeTemplate} selectionMode="multiple"style={{ zIndex: "1", position:"relative"}} className="custom-orgchart"/>
                </Draggable>
                ) : (
                <p className='flex justify-content-center'>No data available to display the organization chart.</p>
            )}
        </div>
    )

}

export default OrganizationHierarchy